import React from 'react';

const SCORE_COLORS = {
	low: '#da1a33',
	medium: '#fcd941',
	high: '#00b24e',
};

const TEXT_COLORS = {
	low: '#b31f35',
	medium: '#fbc722',
	high: '#04a14a',
}

const DEFAULT_COLOR = '#d91a33';
const DEFAULT_TEXT_COLOR = '#b31f35';

const QUARTER_PATH = 'M237.6 866.3H869.1V225.9H981.8V1C442.5 4 5.7 439.2 0 977.9H237.6V866.3Z';

// sx/sy: scale factors to mirror the path into each quadrant
const QUADRANTS = [
	{ num: '1', sx: 1, sy: 1, labels: ['BUILD A', 'COHESIVE', 'LEADERSHIP', 'TEAM'], lx: -520, ly: -460 },
	{ num: '2', sx: -1, sy: 1, labels: ['CREATE', 'CLARITY'], lx: 520, ly: -440 },
	{ num: '3', sx: -1, sy: -1, labels: ['OVERCOMMUNICATE', 'CLARITY'], lx: 520, ly: 440 },
	{ num: '4', sx: 1, sy: -1, labels: ['REINFORCE', 'CLARITY'], lx: -520, ly: 440 },
];

const CircleDiagram = ({ colors, size = 320, textColor }) => {
	const colorMap = {
		1: colors?.q1 ? SCORE_COLORS[colors.q1] || DEFAULT_COLOR : DEFAULT_COLOR,
		2: colors?.q2 ? SCORE_COLORS[colors.q2] || DEFAULT_COLOR : DEFAULT_COLOR,
		3: colors?.q3 ? SCORE_COLORS[colors.q3] || DEFAULT_COLOR : DEFAULT_COLOR,
		4: colors?.q4 ? SCORE_COLORS[colors.q4] || DEFAULT_COLOR : DEFAULT_COLOR,
	};

	const textColorMap = {
		1: colors?.q1 ? TEXT_COLORS[colors.q1] || DEFAULT_TEXT_COLOR : DEFAULT_TEXT_COLOR,
		2: colors?.q2 ? TEXT_COLORS[colors.q2] || DEFAULT_TEXT_COLOR : DEFAULT_TEXT_COLOR,
		3: colors?.q3 ? TEXT_COLORS[colors.q3] || DEFAULT_TEXT_COLOR : DEFAULT_TEXT_COLOR,
		4: colors?.q4 ? TEXT_COLORS[colors.q4] || DEFAULT_TEXT_COLOR : DEFAULT_TEXT_COLOR,
	};

	const gap = 6;
	const vb = 992;
	const font = "'Montserrat', Helvetica, sans-serif";

	return (
		<svg width={size} height={size} viewBox={`${-vb} ${-vb} ${vb * 2} ${vb * 2}`} xmlns="http://www.w3.org/2000/svg">
			{QUADRANTS.map(({ num, sx, sy, labels, lx, ly }) => (
				<g key={num}>
					<path
						d={QUARTER_PATH}
						fill={colorMap[num]}
						transform={`translate(${-sx * gap}, ${-sy * gap}) scale(${sx}, ${sy}) translate(-982, -978)`}
					/>
					<text
						x={lx} y={ly}
						textAnchor="middle" dominantBaseline="central"
						fontSize={660} fontWeight={800}
						fill={textColorMap[num]}
						fontFamily={font}
					>
						{num}
					</text>
					{labels.map((line, i) => (
						<text
							key={line}
							x={lx}
							y={ly + (i - (labels.length - 1) / 2) * 70}
							textAnchor="middle" dominantBaseline="central"
							fontSize={50} fontWeight={800}
							fill={textColor || "#fff"} fontFamily={font} letterSpacing={2}
						>
							{line}
						</text>
					))}
				</g>
			))}
			<text x={0} y={0} textAnchor="middle" dominantBaseline="central"
				fontSize={(60 * size) / 320} fontWeight={700} fill="#58595b" fontFamily={font} letterSpacing={2}>
				ORGANIZATIONAL HEALTH
			</text>
		</svg>
	);
};

export default CircleDiagram;
